import React from 'react';
import fields from '@/constants/fields';
import ErrorMessages from '@/components/errors/ErrorMessages';

const RoleErrorMessages = ({
  category,
  code,
  updateErrors,
  updateProperties,
}) => (
  <ErrorMessages
    category={category}
    code={code}
    entity="role"
    errors={(updateErrors || []).filter((e) => e.context.entity === 'server' || e.fields[0] === fields.PERMISSIONS)}
    onDismiss={(errors) => updateProperties(code, category, { updateErrors: errors })}
  />
);

export default RoleErrorMessages;
